import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import Text from '../../../../text';
type EmptyStateProps = {
  children: React.ReactNode;
};
const EmptyState = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="text-left mt-2 mr-4 mb-2 ml-0"><Text variant="body-2" color="tertiary">{children}</Text></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default EmptyState;